const appInfo = {
  title: process.env.REACT_APP_TITLE,
  logo: process.env.REACT_APP_LOGO,
  logoDark: process.env.REACT_APP_LOGO_DARK,
};
// const appInfo = {
//   title: `e-Caputtin'o`,
//   logo: "/assets/images/BVN_logo.png",
//   logoDark: "/assets/images/BVN_logo.png",
// };
export default appInfo;
